<template>
  <v-dialog
    max-width="700"
    :value="showDialog"
    @update:return-value="closeDialog"
  >
    <v-card>
      <v-form @submit.prevent="saveEdit">
        <v-card-title> Edit todo </v-card-title>
        <v-card-text>
          <v-text-field outlined v-model="editedText"> </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" outlined @click.prevent="deleteTodo">
            Delete
          </v-btn>
          <v-spacer />
          <v-btn @click="closeDialog"> Cancel </v-btn>
          <v-btn type="submit" color="info"> Save </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'editTaskDialog',
  props: ['showDialog', 'taskText', 'taskId'],
  methods: {
    saveEdit() {
      this.$emit('onEditSaved', {
        id: this.taskId,
        value: this.editedText,
      })
    },
    closeDialog() {
      this.$emit('onDialogClosed')
    },
    deleteTodo() {
      this.$emit('onDelete', { id: this.taskId, value: true })
    },
  },
  data: () => ({
    editedText: '',
  }),
  created() {
    this.editedText = this.taskText
  },
}
</script>

<style scoped></style>
